// Shared mixin for login routing logic
export const loginRoutingMixin = {
  computed: {
    defaultApp() { 
      return this.$store.state.admin.defaultApp 
    },
    defaultAppLocation() {
      let location = ''
      switch (this.defaultApp) {
        case 'admin':
          location = 'TheEmptyAdmin'
          break
        case 'capture':
          location = 'StartScan'
          break
        case 'signature':
          location = 'TheSignatureInbox'
          this.$store.dispatch('mainViews/changeMainNav', 'signatureInbox')
          break
        case 'reports':
          location = 'TheEmptyReport'
          break
        case 'storage':
          location = 'VaultFolders'
          break
        case 'workspace':
          location = 'TheWorkspaceHome'
          this.$store.dispatch('mainViews/changeMainNav', 'my-tasks-pending')
          break;
        case 'forms':
          location = 'AllForms'
          break;
        case 'templates':
          this.$store.dispatch('common/getEmailTemplates')
          location = 'AllEmailTemplates'
          this.$store.dispatch('mainViews/changeMainNav', 'all-emails')
          break;
        case 'automation':
          location = 'TheAutomationHome'
          break;
        case 'workflow':
          this.$store.dispatch('workflow/selectWorkflow', 0)
          location = 'AllWorkflows'
          this.$store.dispatch('mainViews/changeMainNav', 'workflow-designer')
          break;
        default:
          location = 'TheWorkspaceHome'
          this.$store.dispatch('mainViews/changeMainNav', 'my-tasks-pending')
          break
      }
      return location
    },
    firstAccessibleAppLocation() {
      let location = ''
      if (this.$store.getters['common/APP_ACCESS_WORKSPACE']) {
        location = 'TheWorkspaceHome'
        this.$store.dispatch('mainViews/changeMainNav', 'my-tasks-pending')
      } else if (this.$store.getters['common/APP_ACCESS_REPORTS']) {
        location = 'TheEmptyReport'
      } else if (this.$store.getters['common/APP_ACCESS_STORAGE']) {
        location = 'VaultFolders'
      } else if (this.$store.getters['common/APP_ACCESS_CAPTURE']) {
        location = 'StartScan'
      } else if (this.$store.getters['common/APP_ACCESS_FORMS']) {
        location = 'AllForms'
      } else if (this.$store.getters['common/APP_ACCESS_SIGNATURE']) {
        location = 'TheSignatureInbox'
        this.$store.dispatch('mainViews/changeMainNav', 'signatureInbox')
      } else if (this.$store.getters['common/APP_ACCESS_WORKFLOW']) {
        this.$store.dispatch('workflow/selectWorkflow', 0)
        location = 'AllWorkflows'
        this.$store.dispatch('mainViews/changeMainNav', 'workflow-designer')
      } else if (this.$store.getters['common/APP_ACCESS_TEMPLATES']) {
        this.$store.dispatch('common/getEmailTemplates')
        location = 'AllEmailTemplates'
        this.$store.dispatch('mainViews/changeMainNav', 'all-emails')
      } else if (this.$store.getters['common/APP_ACCESS_AUTOMATION']) {
        location = 'TheAutomationHome'
      } else if (this.$store.getters['common/APP_ACCESS_ADMIN']) {
        location = 'TheEmptyAdmin'
      }
      return location
    },
  },
  methods: {
    setActiveSubAppForRoute(appType) {
      // Set the activeSubApp based on the app type
      this.$store.dispatch('mainViews/changeActiveSubApp', appType)
    },
    getAppTypeFromRoute(routeName) {
      // Map route names to app types
      const routeToAppMap = {
        'TheEmptyAdmin': 'admin',
        'StartScan': 'capture',
        'TheSignatureInbox': 'signature',
        'TheEmptyReport': 'reports',
        'VaultFolders': 'storage',
        'TheWorkspaceHome': 'workspace',
        'AllForms': 'forms',
        'AllEmailTemplates': 'templates',
        'TheAutomationHome': 'automation',
        'AllWorkflows': 'workflow'
      }
      return routeToAppMap[routeName]
    },
  }
}